import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PartnersTable from "../components/PartnersTable";
import { ToastContainer } from 'react-toastify';

const PartnersListPage = () => {
  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Partnerler" />
      <PartnersTable title="Partnerler" />
    </MasterLayout>
  );
};

export default PartnersListPage;

